// List of company ID that has special case
// When checked cart contain 2 or more course of this company, price and discount is working like it should work
// When checked cart only contain 1 course of this company, discount is not applicable (course will be using real price)

const listCompany = process.env.NEXT_PUBLIC_WHITELIST_COMPANY?.split(', ');

export default listCompany;
